<template>
  <section id="HomeCoverSection">
    <div class="main_container">
      <div class="text_box">
        <h2>
          {{ $store.getters.columnData("home_cover_title") }}
        </h2>
        <p>
          {{ $store.getters.columnData("home_cover_content") }}
        </p>
      </div>
      <div class="button_box">
        <a :href="$store.getters.columnData('company_line')">
          <div class="text">
            <h4 class="title">我要賣機車</h4>
            <p>線上免費估價，價格滿意全台到府收購</p>
          </div>
          <span class="icon material-symbols-rounded"> east </span>
        </a>
        <router-link to="/collections">
          <div class="text">
            <h4 class="title">我要買機車</h4>
            <p>立即瀏覽在庫車輛，線上看車好方便</p>
          </div>
          <span class="icon material-symbols-rounded"> east </span>
        </router-link>
      </div>
    </div>
    <div class="image_box">
      <img
        :src="
          $store.getters.imageUrl($store.getters.columnData('home_cover_image'))
        "
      />
    </div>
  </section>
</template>

<script>
export default {
  name: "HomeCoverSection",
};
</script>
